import { useSelector } from 'react-redux';
import Button from '../webapp/core/Button';

const EventProposalIntro = ({ eventId, onExploreClick }) => {
  const event = useSelector((state) => state.proposalData.data);

  const backgroundEl = (() => {
    if (!event.backgroundUrl) {
      return null;
    }
    const className = 'event-proposal__background';
    switch (event.backgroundUrl.split('.').pop()) {
      case 'mp4':
      case 'm4v':
        return <video className={className} src={`${event.backgroundUrl}#t=0.1`} autoPlay playsInline loop muted />;
      default:
        return <img className={className} src={event.backgroundUrl} alt="" />;
    }
  })();

  return (
    <section
      name="page-0"
      className={[
        'event-proposal__page',
        'event-proposal__page--intro',
        event.liveGallery.theme === 'light' ? 'event-proposal__page--light' : 'event-proposal__page--dark',
      ].join(' ')}
    >
      {backgroundEl}
      <div className="wrapper">
        {!!event.logoUrl &&
          !!event.liveGallery.leadSection &&
          (event.logoLink ? (
            <a href={event.logoLink}>
              <img className="event-proposal__logo" src={event.logoUrl} alt="" />
            </a>
          ) : (
            <img className="event-proposal__logo" src={event.logoUrl} alt="" />
          ))}
        <div className="event-proposal__title-wrapper">
          <div className="event-proposal__title">{event.title}</div>
          {event.subtitle && <div className="event-proposal__subtitle">{event.subtitle}</div>}
        </div>
        <Button color={event.micrositeAccentColor} onClick={onExploreClick}>
          Explore
        </Button>
      </div>
    </section>
  );
};

export default EventProposalIntro;
